import { FormControlLabel } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";
import classNames from "classnames";
import styles from "@/components/dateTime/datepickerGeneric.module.css";
import GenericDateRange from "@/components/dateTime/genericDateRange";

interface DatePickerGenericProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  label: any;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  labelClassname?: any;
  inputClassname?: any;
  textfieldClassname?: any;
  rootClassnames?: any;
  handleClearDate?: () => void;
}

const DatePickerGeneric: FC<DatePickerGenericProps> = ({
  value,
  onChange,
  label,
  disabled = false,
  error = false,
  helperText,
  labelClassname,
  inputClassname,
  textfieldClassname,
  rootClassnames,
  handleClearDate,
}) => {
  const safeValue = dayjs.isDayjs(value) ? value : null;

  return (
    <div>
      <FormControlLabel
        labelPlacement="top"
        sx={{
          margin: "0",
          width: "100%",
          alignItems: "start",
          fontFamily: "inherit !important",
        }}
        disableTypography
        label={
          <section
            className={classNames(styles.label, {
              [labelClassname]: labelClassname,
            })}
          >
            {label}
          </section>
        }
        control={
          <GenericDateRange
            selectionMode="single"
            value={safeValue}
            disabled={disabled}
            onChange={(newValue) => {
              onChange(newValue);
            }}
            onClear={handleClearDate}
            textFieldProps={{
              className: classNames(
                styles.fullWidth,
                styles.bg_color,
                textfieldClassname,
              ),
              error,
              helperText,
              fullWidth: true,

              InputProps: {
                classes: {
                  root: classNames(
                    styles.outlinedInputRounded,
                    rootClassnames,
                  ),
                  input: classNames(inputClassname, styles.inputPadding),
                },
              },
            }}
          />
        }
      />
    </div>
  );
};

export default DatePickerGeneric;
